import { Component, OnInit, Input } from "@angular/core";
import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { NzMessageService, NzModalService } from "ng-zorro-antd";
import { Router } from '@angular/router';

@Component({
  selector: "zx-reset-password",
  templateUrl: "reset-password.component.html"
})
export class ResetPasswordComponent implements OnInit {
  private _loginHandle: Function;
  validateForm: FormGroup;
  @Input() set loginHandle(value: Function) {
    this._loginHandle = value;
  }

  constructor(
    private httpClient: HttpClient,
    private messageService: NzMessageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: NzModalService
  ) {
  }

  ngOnInit() {
    this.validateForm = this.formBuilder.group({
        oldPassword: [null, [Validators.required]],
        password: [null, [Validators.required]],
        confirmPassword: [null, [this.passwordConfirmationValidator]]
      });
  }

  reset() {
    this.httpClient
      .post("/uaa/api/account/change_password", this.validateForm.value)
      .subscribe(
        () => {
          this.messageService.success("修改密码成功");
          this.modalService.closeAll();
          this.router.navigate(['/']);
        },
        () => {
          this.messageService.error("修改密码失败");
        }
      );
  }

  passwordConfirmationValidator = (
    control: FormControl
  ): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls["password"].value) {
      return { confirm: true, error: true };
    }
  };

  validateConfirmPassword() {
    setTimeout(() => {
      this.validateForm.controls["confirmPassword"].updateValueAndValidity();
    });
  }
}
